import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthService } from 'app/auth/services/auth.service';
import { MarketMakingPlatformsStore } from './shared/market-making-platforms.store';

/**
 * Must be canMatch, not canActivate: `loadChildren` resolves while the URL is still being
 * matched, so the ROUTES factory would otherwise see an empty store. Only a failed request
 * blocks the match — an empty list still has static pages under this path to serve.
 */
export const marketMakingPlatformsGuard: CanMatchFn = () => {
  const store = inject(MarketMakingPlatformsStore);
  const authService = inject(AuthService);
  const router = inject(Router);

  // runs before the shell's loggedIn guard, so a deep link would otherwise 401 and cache empty
  if (!authService.getToken()) {
    return router.createUrlTree([authService.loginUrl]);
  }

  return store.platformsReady();
};
